<template>
  <v-container fluid>
    <div class="d-flex align-center pb-3">
      <div>
        <div class="display-1">
          Content Library
        </div>

        <presentation-breadcrumbs :items="[{text: 'List'}]">
        </presentation-breadcrumbs>

      </div>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary"
                 dark
                 v-bind="attrs"
                 v-on="on">
            Add Content
            <v-icon right>
              fas fa-caret-down
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="{name: 'presentations.upload'}">
            Upload Files
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <presentations-table>
    </presentations-table>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import metaService from "../../services/metaService";
import PresentationsTable from "./components/PresentationsTable";
import PresentationBreadcrumbs from "./components/PresentationBreadcrumbs";

export default {
  components: {PresentationBreadcrumbs, PresentationsTable},
  metaInfo() {
    this.$store.commit('setTitle', 'Presentations')
    return {
      title: this.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Content', exact: true, to: {name: 'presentations'}},
        {text: 'List'},
      ],
      presentations: [],
    }
  },
  computed: {
    ...mapGetters([
      'title',
    ])
  }
}
</script>
